import React, { useState } from "react";
import HorizontalProductsList from "./HorizontalProductsList";
import PropTypes from "prop-types";

function HorizontalProductsListWrapper({
  title,
  userAgent,
  rowClassName,
  variables,
  isCollectionProduct = false,
  isMultiple = false,
  limit = 20,
  query,
}) {
  const [isVisible, setIsVisible] = useState(true);

  return isVisible && (
    <section className="Product-other-products">
      <h5 className="Product-section-title">{title}</h5>
      <HorizontalProductsList
        userAgent={userAgent}
        rowClassName={rowClassName}
        variables={variables}
        isCollectionProduct={isCollectionProduct}
        isMultiple={isMultiple}
        limit={limit}
        query={query}
        setIsVisible={setIsVisible}
      />
    </section>
  );
}

export default HorizontalProductsListWrapper;

HorizontalProductsListWrapper.propTypes = {
  title: PropTypes.string,
  userAgent: PropTypes.string.isRequired,
  rowClassName: PropTypes.string.isRequired,
  variables: PropTypes.object.isRequired,
  isMultiple: PropTypes.bool,
  isCollectionProduct: PropTypes.bool,
  limit: PropTypes.number,
  query: PropTypes.object,
};
